module.exports = __webpack_public_path__ + "static/media/cluster-questions.8808bf79.jpg";